<div #wrapperRef class="entity-list-wrapper" [class.deleted-mode]="deletedMode">
  <button *ngIf="deletedMode" class="deleted-indicator" type="button">{{ 'page.deleted' | t:'Deleted Data' }}</button>

  <app-content-skeleton
    *ngIf="showLoadingSkeleton"
    variant="entity-list"
    [columns]="columns.length || 1"
    [count]="6"
  ></app-content-skeleton>

  <div
    class="list-header"
    *ngIf="!showLoadingSkeleton && list.length > 0"
    [style.--columns-count]="columns.length"
    [style.grid-template-columns]="gridTemplateColumns"
  >
    <span *ngFor="let column of columns; trackBy: trackByIndex">{{ column.headerName | t:column.headerName }}</span>
  </div>

  <div #listBodyRef class="list-body" *ngIf="!showLoadingSkeleton && list.length > 0" (click)="closeMenu()" (scroll)="onListBodyScroll($event)">
    <div
      class="list-card"
      *ngFor="let item of list; let i = index; trackBy: trackByIndex"
      [class.menu-open]="activeMenuId === itemId(item, i)"
      [style.background-color]="cardBackgroundColor(item, i)"
      [style.--columns-count]="columns.length"
      [style.grid-template-columns]="gridTemplateColumns"
      (click)="onCardClick(item)"
    >
      <ng-container *ngFor="let column of columns; trackBy: trackByIndex">
        <div class="cell-value" *ngIf="!isMultiLineConfig(column.valueConfig)">
          {{ readValue(item, column.valueConfig) }}
        </div>

        <div class="cell-multiline" *ngIf="isMultiLineConfig(column.valueConfig)">
          <div class="top-line">{{ topLine(item, column.valueConfig) }}</div>
          <div class="bottom-line" *ngIf="bottomLine(item, column.valueConfig)">
            <ng-container *ngIf="!hasBottomLineBadge(bottomLine(item, column.valueConfig)); else bottomLineWithBadge">
              {{ bottomLine(item, column.valueConfig) }}
            </ng-container>
            <ng-template #bottomLineWithBadge>
              <span>{{ bottomLineText(bottomLine(item, column.valueConfig)) }}</span>
              <span class="bottom-line-badge warning" *ngIf="bottomLineBadgeLabel(bottomLine(item, column.valueConfig))">
                {{ bottomLineBadgeLabel(bottomLine(item, column.valueConfig)) }}
              </span>
            </ng-template>
          </div>
        </div>
      </ng-container>

      <button
        *ngIf="canShowMenu()"
        class="card-menu"
        type="button"
        [attr.aria-label]="'entityList.moreOptions' | t:'More options'"
        (click)="toggleMenu(item, i, $event); $event.stopPropagation()"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div
        *ngIf="canShowMenu() && activeMenuId === itemId(item, i)"
        class="card-menu-panel"
        [ngStyle]="menuPanelStyle"
        (click)="$event.stopPropagation()"
      >
        <div class="panel-title">{{ 'common.option' | t:'Options' }}</div>
        <ng-container *ngFor="let action of menuActions">
          <button
            *ngIf="isActionVisible(action, item)"
            type="button"
            class="panel-item"
            [class.danger]="action.danger"
            (click)="onMenuAction(action.key, item); $event.stopPropagation()"
          >
            {{ (action.label || action.key) | t:(action.label || action.key) }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="!showLoadingSkeleton && list.length === 0" class="empty-state">
    {{ emptyMessage | t:emptyMessage }}
  </div>
</div>
